import { render, staticRenderFns } from "./DetalhamentoProposta.vue?vue&type=template&id=07a7e0d1&"
import script from "./DetalhamentoProposta.vue?vue&type=script&lang=js&"
export * from "./DetalhamentoProposta.vue?vue&type=script&lang=js&"
import style0 from "./DetalhamentoProposta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports